import {
  CreateVisitDto,
  CreatePatientDto,
  CreateCaseDto,
  CreateDoctorDto,
  FileType,
  FileParameter,
  CreateResourceDto,
  CreateDataBlockDto,
  QueryFactory,
} from '@lmt/shared-types';

export async function createMeasurement(
  dto: CreateDataBlockDto,
): Promise<number> {
  const measurement = await QueryFactory.DataBlockClient.import_(dto);
  return measurement.id;
}

export async function createVisit(dto: CreateVisitDto): Promise<number> {
  const visit = await QueryFactory.AppointmentEventsClient.createVisit(dto);
  return visit.id;
}

export async function createResource(dto: CreateResourceDto): Promise<number> {
  const resource = await QueryFactory.ResourceClient.createResource(dto);
  return resource.id;
}

export async function createDoctor(dto: CreateDoctorDto): Promise<number> {
  const doctor = await QueryFactory.DoctorClient.createDoctor(dto);
  return doctor.id;
}

export async function createPatient(dto: CreatePatientDto): Promise<number> {
  const patient = await QueryFactory.PatientClient.createPatient(dto);
  return patient.id;
}

export async function createCase(dto: CreateCaseDto): Promise<number> {
  const patientCase = await QueryFactory.CaseClient.createCase(dto);
  return patientCase.id;
}

export async function uploadFile(
  file: FileParameter,
  fileType: FileType,
  comment: string,
  patientId: number,
  dataBlockId: number,
  uploadDateTime?: Date,
): Promise<string> {
  const fileInfo = await QueryFactory.FileClient.create(
    fileType,
    comment,
    dataBlockId,
    patientId,
    null,
    null,
    uploadDateTime ?? null,
    file,
  );
  return fileInfo.id;
}
